(function () {
  var FIRST_KEY = 'bk_utm_first';
  var LAST_KEY = 'bk_utm_last';
  var COUPON_KEY = 'bk_coupon';

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
  }

  function write(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  function deriveMatchType(source, medium) {
    var s = (source || '').toLowerCase();
    var m = (medium || '').toLowerCase();
    if (m === 'cpc' || m === 'ppc' || m.indexOf('paid') !== -1) return 'paid_search';
    if (m === 'organic') return 'organic';
    if (!m && (s === 'google' || s === 'bing' || s === 'yahoo')) return 'organic';
    if (m === 'social' || ['facebook', 'instagram', 'tiktok', 'pinterest', 'twitter', 'linkedin', 'youtube', 'x'].indexOf(s) !== -1) return 'social';
    if (m === 'email') return 'email';
    if (s || m) return 'referral';
    return 'direct';
  }

  function getAttribution() {
    var first = read(FIRST_KEY) || {};
    var last = read(LAST_KEY) || {};
    var coupon = read(COUPON_KEY) || '';
    return {
      acquisition_first_source: first.source || '',
      acquisition_first_medium: first.medium || '',
      acquisition_first_campaign: first.campaign || '',
      acquisition_first_content: first.content || '',
      acquisition_first_term: first.term || '',
      acquisition_last_source: last.source || '',
      acquisition_last_medium: last.medium || '',
      acquisition_last_campaign: last.campaign || '',
      acquisition_last_content: last.content || '',
      acquisition_last_term: last.term || '',
      first_touch_match_type: first.match_type || 'direct',
      coupon_applied: coupon,
    };
  }

  (function capture() {
    var params = new URLSearchParams(window.location.search);
    var source = params.get('utm_source') || '';
    var medium = params.get('utm_medium') || '';
    var campaign = params.get('utm_campaign') || '';
    var content = params.get('utm_content') || '';
    var term = params.get('utm_term') || '';
    var coupon = params.get('discount') || '';

    if (coupon) write(COUPON_KEY, coupon);

    if (!source && !medium && !campaign) return;

    var touch = {
      source: source,
      medium: medium,
      campaign: campaign,
      content: content,
      term: term,
      match_type: deriveMatchType(source, medium),
    };

    if (!read(FIRST_KEY)) write(FIRST_KEY, touch);
    write(LAST_KEY, touch);
  })();

  window.BkUtmTracker = { getAttribution: getAttribution };
})();
